<div class="dialog-container">
	<div class="dialog-title">
		{{ "ORDER_BASKET.NEW_MATERIAL_OPTIONS_DIALOG.DIALOG_TITLE" | translate}}
	</div>
	<div class="dialog-content">
		<mat-card class="menu-card" (click)="uploadCompleteMaterial()">
			<mat-card-content class="menu-card-content">
				<mat-icon class="menu-card-icon">upload</mat-icon>
				<div class="menu-card-title">{{ "ORDER_BASKET.NEW_MATERIAL_OPTIONS_DIALOG.UPLOAD_COMPLETE_MATERIAL_OPTION" | translate }}</div>
				<div class="menu-card-description">{{ "ORDER_BASKET.NEW_MATERIAL_OPTIONS_DIALOG.UPLOAD_COMPLETE_MATERIAL_DESCRIPTION" | translate }}</div>
			</mat-card-content>
		</mat-card>
		<mat-card class="menu-card" (click)="requestProduction()" *ngIf="isCargoEnabled">
			<mat-card-content class="menu-card-content">
				<mat-icon class="menu-card-icon">color_lens</mat-icon>
				<div class="menu-card-title">{{ "ORDER_BASKET.NEW_MATERIAL_OPTIONS_DIALOG.WE_WILL_DESIGN_IT_OPTION" | translate }}</div>
				<div class="menu-card-description">{{ "ORDER_BASKET.NEW_MATERIAL_OPTIONS_DIALOG.WE_WILL_DESIGN_IT_DESCRIPTION" | translate }}</div>
			</mat-card-content>
		</mat-card>
		<mat-card class="menu-card" (click)="repeatPastAd()">
			<mat-card-content class="menu-card-content">
				<mat-icon class="menu-card-icon">history</mat-icon>
				<div class="menu-card-title">{{ "ORDER_BASKET.NEW_MATERIAL_OPTIONS_DIALOG.REPEAT_PAST_AD_OPTION" | translate }}</div>
				<div class="menu-card-description">{{ "ORDER_BASKET.NEW_MATERIAL_OPTIONS_DIALOG.REPEAT_PAST_AD_DESCRIPTION" | translate }}</div>
			</mat-card-content>
		</mat-card>
	</div>
</div>
